export default "__VITE_ASSET__DRmDCG2s__"